const customerGroupEndpoints = {
  accounting: () => '/reporting/customers/groups/accounting'
}

export default customerGroupEndpoints
